import React from 'react'
import RightContent from '../../components/OnBoard/RightContent'
import styles from "./UserOnboarding2.module.css"
import UserOnboardingSteps from '../../components/OnBoard/UserOnboardingSteps'
import {Icon} from "react-icons-kit"
import { arrowRight } from 'react-icons-kit/fa/arrowRight'
import { useNavigate } from 'react-router-dom'
import { ban } from 'react-icons-kit/fa/ban'
import { fileText } from 'react-icons-kit/fa/fileText'
const GSTINStatus = () => {
    const companyRegistration=[{
        id:1,
        icon:fileText,
        title:"GST Registered",
        subTitle:(<>Registered in countries other than India.<br/>Supports multi-currency compliance.
  </>),
        onClick:"/app/registration/companydetailsOnshore",
        isGstinRegistered:true
    },
    {
        id:2,
        icon:ban,
        title:"GST Unregistered",
        subTitle:(<>Locallly registered entity within India.<br/> Includes automated GST & local tax modules.</>),
        onClick:"/app/registration/companydetailsOnshore",
        isGstinRegistered:false
    }
]
const navigate=useNavigate()
  return (
        
         <div className={styles.userOnboarding}>
            <RightContent step={2} />
             <section className={styles.leftContent}>
                    <div className={styles.progressForm} style={{height:"100%", width:"75%", padding:"3rem 1.25rem"}}>
                      <div className={styles.progressForm1}>
                        <div className={styles.onboardingStep}>
                            <UserOnboardingSteps stepNo={2}/>
                        </div>
                        <div className={styles.headingHelperText}>
                            <h1 className={styles.heading} style={{fontSize:"30px", textAlign:"left" }}>Tell us about your company</h1>
                            <div>
                                <p className={styles.supportingText} style={{textAlign:"center", marginTop:"0px"}}>Where is your company registered?</p>
                            </div>
                        </div>
                        <div className={styles.companyDetails} style={{justifyContent:"start"}}>
                        {companyRegistration.map((i,index)=>(
                            <div className={styles.companyDetailsContainer} key={i.id} onClick={()=>{navigate(i.onClick, {state:{isGstinRegistered:i.isGstinRegistered}})}}>
                                <div className={styles.companyIcon}><Icon icon={i.icon} size={25}/></div>
                                <div className={styles.companyTitle}>{i.title}</div>
                                <div className={styles.supportingText} style={{ marginBottom:"1rem", alignSelf:"start"}}> {i.subTitle}</div>
                                <div style={{display:"flex", justifyContent:"end"}}>
                                    <img className={styles.rightIcon} src='/Chevron-Right.svg' alt='/Chevron-Right.svg'/>
                                </div>
                            </div>)
                        )}
                        </div>
                      </div>
                      </div>
             </section>
             </div>
      )
    }

export default GSTINStatus